async function getPlatformAuthenticatorSupport() {
    if (typeof PublicKeyCredential === 'undefined') {
        return 'unavailable';
    }
    try {
        const isAvailable = await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
        return isAvailable ? 'available' : 'unavailable';
    }
    catch {
        return 'unknown';
    }
}
async function getConditionalMediationSupport() {
    if (typeof PublicKeyCredential === 'undefined') {
        return 'unavailable';
    }
    try {
        const isAvailable = await PublicKeyCredential.isConditionalMediationAvailable();
        return isAvailable ? 'available' : 'unavailable';
    }
    catch {
        return 'unknown';
    }
}
async function getPrfSupport() {
    if (typeof PublicKeyCredential === 'undefined') {
        return 'unavailable';
    }
    try {
        const capabilities = await PublicKeyCredential.getClientCapabilities();
        if (capabilities.prf === true || capabilities['extension:prf'] === true) {
            return 'available';
        }
        if (capabilities.prf === false || capabilities['extension:prf'] === false) {
            return 'unavailable';
        }
        return 'unknown';
    }
    catch {
        return 'unknown';
    }
}
export async function getWebCredentialCapabilities() {
    const secureContext = globalThis.isSecureContext === true;
    const webAuthn = typeof PublicKeyCredential !== 'undefined';
    const webCrypto = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined';
    if (!webAuthn) {
        return {
            conditionalMediation: 'unavailable',
            platformAuthenticator: 'unavailable',
            prf: 'unavailable',
            secureContext,
            webAuthn,
            webCrypto
        };
    }
    const [platformAuthenticator, conditionalMediation, prf] = await Promise.all([
        getPlatformAuthenticatorSupport(),
        getConditionalMediationSupport(),
        getPrfSupport()
    ]);
    return {
        conditionalMediation,
        platformAuthenticator,
        prf,
        secureContext,
        webAuthn,
        webCrypto
    };
}
